(function () {
  if (window.fhPrintShowcaseInit) return;
  window.fhPrintShowcaseInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function playQuiet(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Card videos play muted only while on screen
  var videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && !reduceMotion && !v.closest('[hidden]')) playQuiet(v);
      else v.pause();
    });
  }, { threshold: 0.5 }) : null;

  function watchVideos(scope) {
    if (!videoObserver) return;
    scope.querySelectorAll('.fh-ps-card .fh-ps-video').forEach(function (v) {
      if (!v.closest('.fh-ps-dialog')) videoObserver.observe(v);
    });
  }

  function initDialogs() {
    document.querySelectorAll('.fh-ps-dialog').forEach(function (d) {
      if (d.dataset.fhPsReady) return;
      d.dataset.fhPsReady = '1';
      // Stop playback when the large view closes
      d.addEventListener('close', function () {
        d.querySelector('.fh-ps-dialog__body').innerHTML = '';
      });
    });
  }

  // Gallery: when there are more than 250 entries, fetch the next page near the bottom and append it
  var nextObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) loadNext(en.target);
    });
  }, { rootMargin: '1200px 0px' }) : null;

  function loadNext(marker) {
    if (marker.dataset.loading) return;
    marker.dataset.loading = '1';
    nextObserver.unobserve(marker);
    var grid = marker.parentNode.querySelector('.fh-ps-grid');
    fetch(marker.dataset.nextUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('.fh-ps--gallery');
        if (!root) { marker.remove(); return; }
        root.querySelectorAll('.fh-ps-grid > .fh-ps-card').forEach(function (card) {
          grid.appendChild(document.importNode(card, true));
        });
        var next = root.querySelector('.fh-ps-next');
        if (next) {
          marker.dataset.nextUrl = next.dataset.nextUrl;
          delete marker.dataset.loading;
          nextObserver.observe(marker);
        } else {
          marker.remove();
        }
        watchVideos(grid);
        applyFilters(marker.closest('[data-fh-print-showcase]') || document.querySelector('[data-fh-print-showcase]'));
      })
      .catch(function () { delete marker.dataset.loading; });
  }

  function watchNext() {
    if (!nextObserver) return;
    document.querySelectorAll('.fh-ps-next').forEach(function (m) { nextObserver.observe(m); });
  }

  /* ---------- Gallery filters (material, colour family, videos) ---------- */

  var URL_KEYS = { mat: 'material', col: 'colour', video: 'video' };

  function filterState(root) {
    if (!root._fhFilter) root._fhFilter = { mat: '', col: '', video: '' };
    return root._fhFilter;
  }

  function cardMatches(card, st, ignore) {
    var mats = (card.dataset.mat || '').split(' ');
    var cols = (card.dataset.col || '').split(' ');
    if (ignore !== 'mat' && st.mat && mats.indexOf(st.mat) === -1) return false;
    if (ignore !== 'col' && st.col && cols.indexOf(st.col) === -1) return false;
    if (ignore !== 'video' && st.video && !card.hasAttribute('data-video')) return false;
    return true;
  }

  function applyFilters(root) {
    var bar = root.querySelector('[data-fh-filters]');
    if (!bar) return;
    var st = filterState(root);
    var cards = Array.prototype.slice.call(root.querySelectorAll('.fh-ps-grid > .fh-ps-card'));
    var shown = 0;
    closeAll();
    cards.forEach(function (card) {
      var ok = cardMatches(card, st);
      card.hidden = !ok;
      if (ok) shown++;
    });

    // Hide chips that would give no results, given the other active filters
    bar.querySelectorAll('.fh-ps-fchip').forEach(function (chip) {
      var key = chip.dataset.filter, val = chip.dataset.value;
      var active = (st[key] || '') === val;
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', String(active));
      if (!val) return;
      var trial = { mat: st.mat, col: st.col, video: st.video };
      trial[key] = val;
      var any = cards.some(function (c) { return cardMatches(c, trial); });
      chip.hidden = !any && !active;
    });

    var filtered = st.mat || st.col || st.video;
    bar.querySelector('[data-filter-count]').textContent = filtered
      ? 'Showing ' + shown + ' of ' + cards.length + ' prints'
      : cards.length + ' prints';
    bar.querySelector('[data-filter-clear]').hidden = !filtered;
    root.querySelector('[data-filter-empty]').hidden = shown > 0;
    bar.hidden = false;
  }

  function syncUrl(root) {
    if (!history.replaceState) return;
    var st = filterState(root);
    var params = new URLSearchParams(location.search);
    Object.keys(URL_KEYS).forEach(function (k) {
      if (st[k]) params.set(URL_KEYS[k], st[k]); else params.delete(URL_KEYS[k]);
    });
    var q = params.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
  }

  function initFilters() {
    document.querySelectorAll('[data-fh-print-showcase]').forEach(function (root) {
      if (!root.querySelector('[data-fh-filters]') || root._fhFilterReady) return;
      root._fhFilterReady = true;
      var st = filterState(root);
      var params = new URLSearchParams(location.search);
      Object.keys(URL_KEYS).forEach(function (k) { st[k] = params.get(URL_KEYS[k]) || ''; });
      applyFilters(root);
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.fh-ps-fchip');
    var clear = e.target.closest && e.target.closest('[data-filter-clear]');
    if (!chip && !clear) return;
    var root = e.target.closest('[data-fh-print-showcase]');
    if (!root) return;
    var st = filterState(root);
    if (clear) {
      st.mat = st.col = st.video = '';
    } else {
      var key = chip.dataset.filter;
      st[key] = (st[key] === chip.dataset.value) ? '' : chip.dataset.value;
    }
    applyFilters(root);
    syncUrl(root);
  });

  function init() { watchVideos(document); initDialogs(); watchNext(); initFilters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  function closeAll(except) {
    document.querySelectorAll('.fh-ps-spot.is-open').forEach(function (spot) {
      if (spot === except) return;
      spot.classList.remove('is-open');
      spot.querySelector('.fh-ps-dot').setAttribute('aria-expanded', 'false');
      spot.querySelector('.fh-ps-tip').hidden = true;
    });
  }

  function highlight(card, index, on) {
    var spot = card.querySelector('.fh-ps-spot[data-index="' + index + '"]');
    if (spot) spot.classList.toggle('is-hl', on);
  }

  function openDialog(root, card) {
    var dialog = root.querySelector('.fh-ps-dialog');
    var body = dialog.querySelector('.fh-ps-dialog__body');
    var clone = card.cloneNode(true);
    clone.removeAttribute('id');
    // tip ids must stay unique while the clone is open
    clone.querySelectorAll('[id]').forEach(function (el) {
      var newId = el.id + '-lg';
      var ctrl = clone.querySelector('[aria-controls="' + el.id + '"]');
      if (ctrl) ctrl.setAttribute('aria-controls', newId);
      el.id = newId;
    });
    var img = clone.querySelector('.fh-ps-img');
    if (img) { img.setAttribute('sizes', '92vw'); img.loading = 'eager'; }
    card.querySelectorAll('.fh-ps-video').forEach(function (v) { v.pause(); });
    body.innerHTML = '';
    body.appendChild(clone);
    dialog.showModal();
    // Large view: video gets controls and sound (falls back to muted if the browser blocks it)
    var vid = clone.querySelector('.fh-ps-pane--video:not([hidden]) .fh-ps-video');
    if (vid) {
      vid.controls = true;
      vid.preload = 'auto';
      vid.muted = false;
      var p = vid.play();
      if (p && p.catch) p.catch(function () { vid.muted = true; playQuiet(vid); });
    }
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.fh-ps-dot');
    if (dot) {
      var spot = dot.closest('.fh-ps-spot');
      var open = !spot.classList.contains('is-open');
      closeAll(spot);
      spot.classList.toggle('is-open', open);
      dot.setAttribute('aria-expanded', String(open));
      spot.querySelector('.fh-ps-tip').hidden = !open;
      return;
    }

    var toggle = e.target.closest('.fh-ps-toggle');
    if (toggle) {
      var card = toggle.closest('.fh-ps-card');
      var off = !card.classList.contains('fh-ps-dots-off');
      if (off) closeAll();
      card.classList.toggle('fh-ps-dots-off', off);
      toggle.setAttribute('aria-pressed', String(off));
      toggle.querySelector('.fh-ps-toggle__text').textContent = off ? 'Show dots' : 'Hide dots';
      return;
    }

    var swap = e.target.closest('.fh-ps-swap');
    if (swap) {
      var media = swap.closest('.fh-ps-media');
      var toPhoto = swap.dataset.showing === 'video';
      var photoPane = media.querySelector('.fh-ps-pane--photo');
      var videoPane = media.querySelector('.fh-ps-pane--video');
      var v = videoPane && videoPane.querySelector('.fh-ps-video');
      closeAll();
      if (photoPane) photoPane.hidden = !toPhoto;
      if (videoPane) videoPane.hidden = toPhoto;
      if (v) { if (toPhoto) v.pause(); else if (v.controls || !reduceMotion) playQuiet(v); }
      swap.dataset.showing = toPhoto ? 'photo' : 'video';
      swap.querySelector('.fh-ps-swap__text').textContent = toPhoto ? 'Video' : (media.querySelector('.fh-ps-spot') ? 'Photo + dots' : 'Photo');
      return;
    }

    var root = e.target.closest('[data-fh-print-showcase]');
    if (!root) { closeAll(); return; }

    if (e.target.closest('.fh-ps-dialog__close')) {
      e.target.closest('.fh-ps-dialog').close();
      return;
    }
    if (e.target.classList.contains('fh-ps-dialog')) { // backdrop click
      e.target.close();
      return;
    }

    var inDialog = e.target.closest('.fh-ps-dialog');
    if (!inDialog && (e.target.closest('.fh-ps-expand') || e.target.classList.contains('fh-ps-img') || e.target.classList.contains('fh-ps-video'))) {
      closeAll();
      openDialog(root, e.target.closest('.fh-ps-card'));
      return;
    }

    if (!e.target.closest('.fh-ps-tip')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  ['mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var item = e.target.closest && e.target.closest('.fh-ps-legend__item[data-index]');
      if (item) highlight(item.closest('.fh-ps-card'), item.dataset.index, true);
    });
  });
  ['mouseout', 'focusout'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var item = e.target.closest && e.target.closest('.fh-ps-legend__item[data-index]');
      if (item && !item.contains(e.relatedTarget)) highlight(item.closest('.fh-ps-card'), item.dataset.index, false);
    });
  });
})();
